export default {
  siteId: "7",
  siteName: "mx",
  site: "mx",
  lang: "Spanish",
  langCode: "es-ES",
  activityName: "",
  POST: "POST",
  Score: "Puntaje",
  Title: "Título",
  Review: "Resuñas",
  Media: "Medios de Comunicación",
  MoreQa:
    "Completa todas las preguntas a continuación para obtener recompensas adicionales.",
  "Please enter a star rating for this review":
    "Ingrese una calificación de estrellas para esta reseña",
  "Review’s title can’t be empty":
    "El título y el cuerpo de la reseña no pueden estar vacíos",
  "Review’s body can’t be empty":
    "El título y el cuerpo de la reseña no pueden estar vacíos",
  "Please upload a media less than 10 megabytes":
    "Sube un archivo multimedia de menos de 10 megabytes",
  "Please upload a media less than 20 megabytes":
    "Sube un archivo multimedia de menos de 20 megabytes",
  shopping: "https://mx.cupshe.com/",
  mailto: "customercare",
  pageTitle: "Resuñas de los Clientas",
  "VIEW COMMENTS": "VIEW COMMENTS",
  "GO SHOPPING": "GO SHOPPING",
  email: "Email",
  "contact us": "contact us",
  contactUrl: "https://mx.cupshe.com/pages/contact-us",
  chat: "chat",
  next: "next",
  copyright: "Copyright © {year} Cupshe {sitename}, All rights reserved.",
};
